
import { defineComponent, reactive, toRefs, computed, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import CExportFile from '@/components/c-export-file'
import CUpload from '@/components/c-upload'
import { setBaseUrl } from '@/config/url'
import { getToken } from '@/utils/auth'
import moment from 'moment'
import { dropdownOfEnterprise, getDeviceFactoryList, getDeviceMaintainList } from '../api'

export default defineComponent({
  name: 'vehicle-device-import', // 代导入车载设备弹窗
  components: {
    CExportFile,
    CUpload
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'refreshList'],
  setup(props, { emit }) {
    const data = reactive({
      visible: props.modelValue,
      formData: ref<any>({})
    })

    // 导入接口上传地址
    const importAction =
      setBaseUrl().baseUrl + '/ccclubs-admin/device/terminal/import'
    // 上传请求头
    const uploadHeaders = { token: getToken() }
    // 代导入模板文件名：车载设备代导入模板+年月日时分秒
    const importFileName = `车载设备代导入模板${moment().format('YYYYMMDDHHmmss')}`
    // 上传附带参数（选择的企业与设备型号）
    const uploadData = computed(() => ({
      companyUuid: data.formData.companyUuid,
      deviceMaintainUuid: data.formData.deviceMaintainUuid
    }))

    // 企业名称远程搜索
    const remoteData1 = reactive({
      options: [] as any[],
      isLoading: false,
      remoteMethod: (val: string) => {
        dropdownOfEnterprise({ value: val }).then((res: any) => {
          remoteData1.options = (res.data || []).map((item: any) => {
            return {
              label: item.value,
              value: item.key
            }
          })
        })
      }
    })

    // 设备型号级联选择（厂商-型号懒加载，与主页面一致）
    const cascaderProps = {
      lazy: true,
      emitPath: false,
      lazyLoad(node: any, resolve: any) {
        const { level, data } = node

        if (level === 0) {
          getDeviceFactoryList({}).then((res: any) => {
            const list = (res && res.data) || []
            resolve(
              list.map((i: any) => ({
                value: i.deviceFactoryUuid,
                label: i.deviceFactoryName,
                leaf: level >= 1
              }))
            )
          })
        }

        if (level === 1) {
          getDeviceMaintainList({ deviceFactoryUuid: data.value }).then(
            (res: any) => {
              const list = (res && res.data) || []
              resolve(
                list.map((i: any) => ({
                  value: i.deviceMaintainUuid,
                  label: i.deviceMaintainType,
                  leaf: level >= 1
                }))
              )
            }
          )
        }
      }
    }

    // 关闭弹窗并重置
    const handleCloseDialog = () => {
      data.formData = {}
      remoteData1.options = []
      emit('update:modelValue', false)
    }

    // 上传导入成功回调
    const onUploadSuccess = (file: any) => {
      const res = (file.response && file.response.data) || {}
      ElMessage.success(
        `新增 ${res.successCount || 0} 条，更新 ${res.updateCount || 0} 条，失败 ${
          res.failCount || 0
        } 条`
      )
      if (res.failList && res.failList.length) {
        ElMessageBox.alert(res.failList.join('<br>'), '导入失败原因', {
          dangerouslyUseHTMLString: true
        })
      }
      emit('refreshList')
    }

    // 上传移除回调
    const onUploadRemove = () => {}

    return {
      ...toRefs(data),
      remoteData1,
      cascaderProps,
      importAction,
      importFileName,
      uploadHeaders,
      uploadData,
      handleCloseDialog,
      onUploadSuccess,
      onUploadRemove
    }
  }
})
